__turbopack_context__.v({
  "content": "Card-module-scss-module__B1YHha__content",
  "image": "Card-module-scss-module__B1YHha__image",
  "isClicked": "Card-module-scss-module__B1YHha__isClicked",
  "label": "Card-module-scss-module__B1YHha__label",
  "root": "Card-module-scss-module__B1YHha__root",
});
